import { hasExtension } from '@packages/core/utils';

/**
 * Checks whether a filename has the `.sepf` extension (case-insensitive). SEPF files are
 * Subaru Electronic Platform Format files used in CID-CVN worksheet attachments.
 *
 * Built on the generic `hasExtension` utility for reuse.
 *
 * @param filename - the filename or path to check
 * @returns true if the filename ends with `.sepf`
 * @example
 * ```ts
 * hasSepfExtension('calibration.SEPF'); // true
 * hasSepfExtension('report.pdf');       // false
 * ```
 */
export function hasSepfExtension(filename: string): boolean {
    return hasExtension(filename, 'sepf');
}
